import { useState } from 'react';
import { Link } from 'react-router-dom';

import { Eye, EyeOff } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

import JaberAlkhawaterLogo from '../assets/jaber-alkhawater-logo.png';
import { cdnImage } from '@/lib/cdn';

const LoginComponent = () => {
	const [showPassword, setShowPassword] = useState(false);
	const [idEmail, setIdEmail] = useState('');
	const [idPassword, setIdPassword] = useState('');

	const [loginBtnText, setLoginBtnText] = useState('تسجيل الدخول');
	const [isStartLogin, setIsStartLogin] = useState(false);
	const [isLoginError, setIsLoginError] = useState(false);

	const handleLogSubmit = (e: React.FormEvent) => {
		e.preventDefault();

		try {
			setLoginBtnText('جاري تسجيل الدخول ...');
			setIsStartLogin(true);
			setIsLoginError(false);

			const formData = new FormData();
			formData.append('email', idEmail);
			formData.append('password', idPassword);

			const url = '/api/login';
			const doLogin = async () => {
				const response = await fetch(url, {
					method: 'POST',
					body: formData,
				});
				const { email, user, role, operation } = await response.json();
				if (operation === 'SUCCESS') {
					localStorage.setItem('isSetAppContext', 'TRUE');
					const appContext = { isLogged: true, user: user, email: email, role: role };
					localStorage.setItem('appContext', JSON.stringify(appContext));
					window.location.replace('/');
				} else {
					setLoginBtnText('تسجيل الدخول');
					setIsStartLogin(false);
					setIsLoginError(true);
				}
			};
			doLogin();
		} catch (error) {
			console.error('Error: ', error);
			setLoginBtnText('تسجيل الدخول');
			setIsStartLogin(false);
			setIsLoginError(true);
		}
	};

	return (
		<div className="flex min-h-screen items-center justify-center p-4" style={{ backgroundColor: '#e6e6b8' }}>
			<div className="w-full max-w-md">
				{/* Logo */}
				<Link to="/" className="mb-8 flex items-center justify-center gap-3">
					<div className="flex h-10 w-10 items-center justify-center">
						<img src={cdnImage('jaber-alkhawater-logo.png', JaberAlkhawaterLogo)} alt="جبر الخواطر" className="text-primary-foreground" />
					</div>
					<span className="text-2xl font-bold text-foreground">جبر الخواطر</span>
				</Link>

				<div className="rounded-2xl border p-10 shadow-elevated" style={{ backgroundColor: '#ffe600' }}>
					<h1 className="mb-2 text-center text-2xl font-bold text-foreground">تسجيل الدخول</h1>
					<p className="mb-6 text-center text-sm text-muted-foreground">أدخل بياناتك للوصول إلى حسابك</p>

					<br />
					<form onSubmit={handleLogSubmit} className="space-y-4">
						<div className="space-y-2">
							<Label htmlFor="email" className="font-bold">
								البريد الإلكتروني
							</Label>
							<Input
								id="email"
								type="email"
								placeholder=""
								className="text-right"
								style={{ borderColor: 'green' }}
								value={idEmail}
								onChange={(e) => setIdEmail(e.target.value as string)}
								required
								autoFocus={true}
							/>
						</div>

						<div className="space-y-2">
							<Label htmlFor="password" className="font-bold">
								كلمة المرور
							</Label>
							<div className="relative">
								<Input
									id="password"
									type={showPassword ? 'text' : 'password'}
									placeholder="••••••••"
									className="pl-10 text-right"
									style={{ borderColor: 'green' }}
									value={idPassword}
									onChange={(e) => setIdPassword(e.target.value as string)}
									required
								/>

								<button
									type="button"
									onClick={() => setShowPassword(!showPassword)}
									className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground">
									{showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
								</button>
							</div>
						</div>

						<br />
						{isLoginError && <label style={{ color: 'red' }}>خطأ في البريد الالكتروني أو كلمة المرور أو الحساب موقف مؤقتا</label>}
						<br />
						<Button type="submit" className="w-full" size="lg" disabled={isStartLogin}>
							{loginBtnText}
						</Button>
					</form>

					<p className="mt-6 text-center text-sm text-muted-foreground">
						ليس لديك حساب؟{'  '}
						{'  '}
						<Link to="/register" className="font-semibold text-primary hover:underline">
							إنشاء حساب جديد
						</Link>
					</p>
				</div>

				<p className="mt-4 text-center text-muted-foreground text-sm">
					<Link to="/" className="hover:text-primary">
						العودة إلى الصفحة الرئيسية
					</Link>
				</p>
			</div>
		</div>
	);
};

export default LoginComponent;
